<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
        <h1> Добро пожаловать!</h1>
        <p>Вы авторизовались как {{getProfile.displayname}}</p>
      <div v-if="updateUserPass">
        <hr>
        <p>Вам нужно сменить текущий пароль, на новый</p>
        <label for="newp">
          <i>Новый пароль</i>
          <input type="password" id="newp" v-model="newp">
        </label>
        <label for="newpc">
          <i>Новый пароль, повтор</i>
          <input type="password" id="newpc" v-model="newpc">
        </label>
        <hr>
        <button v-on:click="savePas">Сохранить нвоый пароль</button>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapGetters, mapState} from 'vuex'
export default {
  name: 'home',
  data(){
    return {
      updateUserPass:false,
      newp:'',
      newpc:'',
      failPass:['12345', '11111', 'admin', 'qwert', '54321', '00000', '12121', '77777', '99999', 'qwerty', 'guest', 'hello', 'jesus', 'password', '12344', '65432', 'abcde', '66666', '88888', '22222', '33333', '44444', '55555', 'user1', 'asdfg', 'login', 'super', 'ninja', 'money', 'music', 'water', 'lucky', 'angel', 'happy', 'point', 'world', 'power', 'crazy', 'smile', 'house', 'black', 'white', 'smart', 'rocks', 'sweet', 'heart', 'queen', 'king1', 'young', 'tiger', 'alpha', 'delta', 'omega', 'gamer', 'sport', 'media', 'photo', 'video', 'cloud', 'phone', 'sound', 'light', 'night', 'dream', 'stars', 'earth', 'space', 'linux', 'cisco', 'proxy', 'store', 'start', 'close', 'open1', 'trust', 'truth', 'faith', 'peace', 'ghost', 'demon', 'magic', 'brain', 'logic', 'think', 'study', 'learn', 'books', 'paper', 'write', 'paint', 'green', 'blues', 'radio', 'audio', 'motor', 'speed', 'turbo', 'nitro', 'rapid', 'quick'],
    }
  },
  components: {},
  methods:{
    savePas(){
      let run = true;
      if (this.newp.trim() !== this.newpc.trim() || this.newp.trim().length < 5) {
        run = false;
        alert('пароли не совпадают, или длинна пароля меньше 5 символов');
      }
      if (this.failPass.includes(this.newp)) {
        run = false;
        alert('Данный пароль запрещен для установки');
      }
      if (run) {
        this.$myApi.singleRequest({
          action:'userUpdateValue',
          data: this.newp
        }).then(res=>{
          if (res.result) {
            localStorage.removeItem('user-token');
            document.location.href = '/'
          }
        }).catch(res=>{
          alert(res.Response.ExecutionError.ExecutionErrorMessage);
        });
      }
    },
    loadOperatorScript:function () {
      if (this.getIncomeScripts.length == 0) {
        this.$myApi.scriptContent()
        .then((result)=>{
          this.$store.dispatch('setScripts',result)})
        .catch((msg)=>{console.log(msg)});
      }
    },
    checkPassword: function () {
        this.$myApi.singleRequest({
          action:'checkUsersUpdate'
        }).then(res=>{
          this.updateUserPass = res.result;
        })
    }
  },
  computed:{
    ...mapGetters(['getIncomeScripts','getProfile']),
  },
  mounted: function () {
    this.loadOperatorScript();
    this.checkPassword();
  }
}
</script>

<style scoped>
  #formArea{width: 900px;}
  @media screen and (max-width: 1600px){
    #pageContent{position: absolute;height: auto;}
  }
</style>
